export default function ContactSection() {
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.querySelector('[name="website_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      const successEl = document.getElementById('contact-success');
      if (successEl) successEl.style.display = 'block';
      const errorEl = document.getElementById('contact-error');
      if (errorEl) errorEl.style.display = 'none';
      return;
    }

    try {
      const formData = new FormData(form);
      formData.delete('website_alt');
      const params = new URLSearchParams();
      formData.forEach((value, key) => {
        params.append(key, value as string);
      });

      const response = await fetch('https://readdy.ai/api/form/d9lpise8mbnljin59gig', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });

      const responseText = await response.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (response.ok && parsed?.code === 'OK') {
        const successEl = document.getElementById('contact-success');
        if (successEl) successEl.style.display = 'block';
        const errorEl = document.getElementById('contact-error');
        if (errorEl) errorEl.style.display = 'none';
        form.reset();
      } else {
        const errorEl = document.getElementById('contact-error');
        if (errorEl) {
          errorEl.style.display = 'block';
          errorEl.textContent = parsed?.meta?.message || parsed?.message || '提交失败，请稍后再试';
        }
        const successEl = document.getElementById('contact-success');
        if (successEl) successEl.style.display = 'none';
      }
    } catch {
      const errorEl = document.getElementById('contact-error');
      if (errorEl) {
        errorEl.style.display = 'block';
        errorEl.textContent = '网络错误，请稍后再试';
      }
      const successEl = document.getElementById('contact-success');
      if (successEl) successEl.style.display = 'none';
    }
  };

  return (
    <section id="contact" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[700px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            有任何建议、反馈或合作意向，欢迎给我们留言
          </p>
        </div>

        <form
          onSubmit={handleSubmit}
          data-readdy-form
          className="bg-background-50 rounded-2xl p-6 md:p-8 space-y-5"
        >
          <div className="honeypot-field">
            <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden readOnly />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            <div>
              <label className="block text-sm font-medium text-foreground-700 mb-2">姓名</label>
              <input
                type="text"
                name="name"
                required
                placeholder="请输入您的姓名"
                className="w-full px-4 py-3 rounded-lg border border-secondary-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-foreground-700 mb-2">邮箱</label>
              <input
                type="email"
                name="email"
                required
                placeholder="请输入您的邮箱"
                className="w-full px-4 py-3 rounded-lg border border-secondary-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground-700 mb-2">留言主题</label>
            <input
              type="text"
              name="subject"
              required
              placeholder="请输入留言主题"
              className="w-full px-4 py-3 rounded-lg border border-secondary-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground-700 mb-2">留言内容</label>
            <textarea
              name="message"
              required
              maxLength={500}
              rows={5}
              placeholder="请输入您的留言内容（最多500字）"
              className="w-full px-4 py-3 rounded-lg border border-secondary-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors resize-none"
            ></textarea>
          </div>

          <button
            type="submit"
            className="w-full py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-send-plane-line mr-2"></i>发送留言
          </button>

          <div id="contact-success" style={{ display: 'none' }} className="p-4 rounded-lg bg-green-50 text-green-700 text-sm text-center">
            留言发送成功！感谢您的反馈，我们会尽快处理。
          </div>
          <div id="contact-error" style={{ display: 'none' }} className="p-4 rounded-lg bg-red-50 text-red-700 text-sm text-center"></div>
        </form>
      </div>
    </section>
  );
}